const HISTORY_ACTIONS = {
  GET_TRANSACTION_HISTORY: "GET_TRANSACTION_HISTORY",
  SET_TRANSACTION_HISTORY: "SET_TRANSACTION_HISTORY",
  SET_INTERNALTRANSFER_HISTORY: "SET_INTERNALTRANSFER_HISTORY",
  SET_WITHDRAWAL_HISTORY: "SET_WITHDRAWAL_HISTORY",
  SET_DEPOSIT_HISTORY: "SET_DEPOSIT_HISTORY",
};
export default HISTORY_ACTIONS;
